import { makeEnum } from 'services/store/utils-actions';

export const path = 'auth';

export const types = makeEnum(
  'REGISTER_USER',
  'SET_AUTH',
);
